import { useContext, /**useRef*/ } from "react";
import { useValidators } from "@/shared/utils/validate";
import { ErrorDialogContext, /**errorHandledAsync,*/ errorHandledSync, } from "@/shared/context/error-context";
import { SignUpService } from "@/features/user/services/sign-up-service";
import { useSignUpStates } from "@/features/user/hooks/use-sign-up-states";
import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { useNavigate } from "react-router-dom";
import { utilities } from "@/shared/utils/utility";
import { EndpointPathNames } from "@/shared/config/endpoint-path";
import { LoadingModalContext } from "@/shared/components/loading/loading-context";

export const useSignUpUser = () => {
  const navigate = useNavigate();
  const signUpService = new SignUpService();

  const {
    userName, // ユーザー名
    setUserName,
    userNameError, // ユーザー名のエラーメッセージ
    setUserNameError,
    isActiveNextButton, // 次へボタンの有効フラグ
    isShowErrorDialog, // エラーダイアログ表示フラグ情報
    setIsShowErrorDialog,
  } = useSignUpStates();

  // グローバルエラーハンドリング
  const { setError } = useContext(ErrorDialogContext);

  // ローディング用コンテキスト
  const loadingCtx = useContext(LoadingModalContext);

  // バリデーション関数の呼び出し
  const { validatesForm } = utilities();
  const { userNameValidator } = useValidators();

  // ユーザー名の変更
  const onChangeUserName = (newValue: string) => { setUserName(newValue);};

  // ユーザー名登録画面へ遷移
  const navigateSignUpCompleted = (userName: string, ownerId: string) => {
    navigate(
      EndpointPathNames.SIGN_UP_COMPLETED, 
      { state: { userName: userName, email: ownerId } }
    );
  };

  // ボタン押下イベント ======================================
  // 「次へ」押下時のコールバック
  const onClickNext = async (token: string, password: string, userName: string) => {
    loadingCtx.setIsLoading(true);

    try {
      const hasValidationError = validatesForm([userNameValidator], userName, setUserNameError);

      if (!hasValidationError) {
        return;
      }

      // tokenのチェック
      if (token === "") {
        navigate(EndpointPathNames.ERROR, { replace: true });
        return;
      }

      const res = await signUpService.activate({
        token: token,
        owner_pw: password,
        owner_name: userName,
      });

      // エラーハンドリング


      // ユーザー登録完了画面へ遷移
      navigateSignUpCompleted(userName, res.owner_id);
    } catch (error) {
      if (error instanceof MoneyLinkException) {
        const { messageBody } = error.error.props;

        // エラーページ遷移の際にメッセージを渡す
        navigate(EndpointPathNames.ERROR, { replace: true, state: messageBody ?? "" });
      } else {
        throw MoneyLinkException.wrapCallback(error, () => { /**intentionally empty */ });
      }
    } finally {
      loadingCtx.setIsLoading(false);
    }
  };

  // エラーダイアログを閉じる
  const closeErrorDialog = () => {
    setIsShowErrorDialog({
      isError: false,
      errorMessage: "",
    });
  };

  return {
    userName,
    userNameError,
    isActiveNextButton,
    isShowErrorDialog,
    onChangeUserName: errorHandledSync(onChangeUserName, setError),
    onClickNext: errorHandledSync(onClickNext, setError),
    closeErrorDialog: errorHandledSync(closeErrorDialog, setError),
  };
};
